import { createFileRoute } from '@tanstack/react-router'
import { ProjectPage } from '@/components/projects/ProjectPage'
import { projectDetailQueryOptions } from '@/lib/queries'

export const Route = createFileRoute('/_app/projects/$id')({
  loader: ({ context: { queryClient }, params }) =>
    queryClient.ensureQueryData(projectDetailQueryOptions(params.id)),
  component: ProjectPage,
})
